import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { publicRoutes } from './public';
import { AdminLayout } from '../modules/admin';
import { Login } from '../pages/admin';
import { adminRoutes } from './admin';
import NotFound from '../pages/NotFound';
import { useAuthContext } from '../modules/auth';
import ScrollToTop from '../components/shared/ScrollToTop';

export default function AppRoutes() {
  const { user, isAdmin } = useAuthContext();

  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public Routes */}
        {publicRoutes.map(route => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}

        {/* Admin Routes */}
        <Route 
          path="/admin/login" 
          element={
            user ? <Navigate to="/admin" replace /> : <Login />
          } 
        />

        <Route 
          path="/admin/*" 
          element={
            user && isAdmin ? (
              <AdminLayout />
            ) : (
              <Navigate to="/admin/login" state={{ from: window.location.pathname }} replace />
            )
          }
        >
          {adminRoutes.map(route => (
            <Route
              key={route.path}
              path={route.path}
              element={<route.component />}
            />
          ))}
        </Route>

        {/* Catch all 404 route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}